const PagePath = {
  HOME: "/",
  TESLA: "/tesla",
  MODEL: "/model",
  CUSTOMER: "/Customer",
  SUCCESS: "/success",
};


export default PagePath;